import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Box from 'reusecore/src/elements/Box';
import Text from 'reusecore/src/elements/Text';
import Heading from 'reusecore/src/elements/Heading';
import Button from 'reusecore/src/elements/Button';
import Image from 'reusecore/src/elements/Image';
import FeatureBlock from '../../../components/FeatureBlock';
import Container from '../../../components/UI/Container';
import Particles from '../../Agency/Particle';
import { Icon } from 'react-icons-kit';
import { socialTwitter } from 'react-icons-kit/ionicons/socialTwitter';
import { facebook2 } from 'react-icons-kit/icomoon/facebook2';
import BannerBG from '../../../assets/image/crypto/white_bg1.svg';
import BannerWrapper, { BgImageWrapper } from './bannerSection.style';

import { HEADERS } from '../../../data/Crypto/index.js'

import NetlifyIdentity, { openNetlifyModal, getUser, getNetlifyIdentity } from '../../../utils/netlifyIdentity'
import StripeForm from '../../../utils/StripeForm'

const BannerSection = ({
  row,
  col,
  title,
  btnStyle,
  description,
  discountText,
  discountAmount,
  outlineBtnStyle,
}) => {
  const ButtonGroup = () => {
    return(
      <Fragment>
        <Button title="Get Your Site" {...btnStyle} 
          onClick={() => { openNetlifyModal() }}
        />
        <Button
          title="View Demo"
          variant="textButton"
          icon={<i className="flaticon-next" />}
          {...outlineBtnStyle}
          onClick={() => { openNetlifyModal() }}
        />
      </Fragment>
    )
  };

class PaymentFlow extends React.Component {
  constructor(props) {
    super(props);
    this.state = { user: undefined, hasPaid: false }

    this.updateCurrentUser = this.updateCurrentUser.bind(this);
  }

  componentDidMount() {
    window.addEventListener('load', () => { this.listenNetlifyEvents() })
    window.addEventListener('load', () => { console.log('PAGE LOADED!') })
  }

  listenNetlifyEvents() {
    console.log("listenNetlifyEvents() CALLED!")
    const netlifyIdentity = window.netlifyIdentity

    netlifyIdentity.on('init', this.updateCurrentUser);
    netlifyIdentity.on('login', this.updateCurrentUser);
    netlifyIdentity.on('logout', this.updateCurrentUser);
    netlifyIdentity.on('error', err => console.error('Error', err));
    netlifyIdentity.on('open', this.updateCurrentUser);
    netlifyIdentity.on('close', this.updateCurrentUser);

    this.updateCurrentUser()
  }

  updateCurrentUser() {
    console.log('update current user called.')
    const user = getUser()

    if(this.state.user != user)
      this.setState({ user: user })

    return null
  }

  paymentForm() {
    if(typeof window !== 'undefined')
      return(<StripeForm cb={(paymentComplete) => { return paymentComplete ? this.setState({hasPaid: true}) : null }}/>)
    else
      return(null)
  };

  renderButtons() {
    console.log('renderButton: ', this.state.hasPaid)
    if(!this.state.hasPaid)
      if(this.state.user != undefined)
        return this.paymentForm()
      else
        return(<ButtonGroup />)
    else
      return(<Heading
        style={{color: 'white', fontSize: 32}}
        content={"Error! Nothing has been charged or stored."}
      />)
  }

  render() {
    console.log('hasPaid: ', this.state.hasPaid)
    return(
      <div>
        <NetlifyIdentity />
        {this.renderButtons()}
      </div>
    )
  }
}

  const ShareButtonGroup = () => (
    <Fragment>
      <Button
        title="Share on Twitter"
        variant="textButton"
        iconPosition="left"
        icon={<Icon icon={socialTwitter} />}
        {...outlineBtnStyle}
        className="btnWithoutColor"
      />
      <Button
        title="Share on Facebook"
        variant="textButton"
        iconPosition="left"
        icon={<Icon icon={facebook2} />}
        {...outlineBtnStyle}
        className="btnWithoutColor"
      />
    </Fragment>
  );
  return (
    <BannerWrapper id="banner_section">
      <Particles />
      <BgImageWrapper>
        <Image src={BannerBG} alt="banner background" />
      </BgImageWrapper>
      <Container>
        <Box className="row" {...row}>
          <Box className="col" {...col}>
            <FeatureBlock
              title={
                <Heading
                  content={HEADERS[0].header}
                  {...title}
                />
              }
              description={
                <Text
                  content={HEADERS[0].subtext}
                  {...description}
                />
              }
              button={<PaymentFlow />}
            />
            {/*<FeatureBlock button={<ShareButtonGroup />} />*/}
          </Box>
        </Box>
      </Container>
    </BannerWrapper>
  );
};

BannerSection.propTypes = {
  title: PropTypes.object,
  btnStyle: PropTypes.object,
  description: PropTypes.object,
  contentStyle: PropTypes.object,
  discountText: PropTypes.object,
  discountAmount: PropTypes.object,
  outlineBtnStyle: PropTypes.object,
};

BannerSection.defaultProps = {
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px',
    alignItems: 'center',
  },
  col: {
    pr: '15px',
    pl: '15px',
    width: ['100%', '100%', '100%', '60%', '65%'],
  },
  title: {
    fontSize: ['26px', '34px', '42px', '42px', '47px'],
    fontWeight: '700',
    color: '#fff',
    letterSpacing: '-0.025em',
    mb: ['20px', '25px'],
    lineHeight: '1.31',
  },
  description: {
    fontSize: ['14px', '16px', '18px', '18px', '20px'],
    color: '#fff',
    lineHeight: '30px',
    mb: '0',
    maxWidth: '550px',
  },
  btnStyle: {
    minWidth: ['120px', '156px'],
    fontSize: '15px',
    fontWeight: '700',
    borderRadius: '6px',
  },
  outlineBtnStyle: {
    minWidth: ['130px', '156px'],
    fontSize: '16px',
    fontWeight: '700',
    color: '#fff',
    p: '5px 10px',
  },
};

export default BannerSection;
